import { Routes, Route as RouteItem, useNavigate } from "react-router-dom";
import Layout from "../components/layout/Layout";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import RippleButton from "../components/common/RippleButton";
import Menu from "../features/menu/Menu";
import Rights from "../features/rights/Rights";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import { PrivateLoginRoute, PrivateRoute } from "./PrivateRoute";
import Inquiry from "../features/inquiry/Inquiry";
// import CreateInquiry from "../features/inquiry/CreateInquiry";
import Testimonial from "../features/testimonial/Testimonial";
import SeoTag from "../features/seotag/SeoTag";
import CreateSeoTag from "../features/seotag/CreateSeoTag";
import Banner from "../features/banner/Banner";
import CreateBanner from "../features/banner/CreateBanner";
import Blog from "../features/blog/Blog";
import CreateBlog from "../features/blog/CreateBlog";
import FAQ from "../features/faq/FAQ";
import CreateFAQ from "../features/faq/CreateFAQ";
import CMS from "../features/cms/CMS";
import CreateCMS from "../features/cms/CreateCMS";
import LoginNew from "../features/login/Login";
import Setting from "../features/setting/Setting";
import Dashboard from "../features/dashboard/Dashboard";
import Gallery from "../features/gallery/Gallery";
import Attractions from "../features/attraction/Attractions";
import CreateAttractions from "../features/attraction/CreateAttractions";
import Degree from "../features/degree/Degree";
import Country from "../features/country/Country";
import State from "../features/state/State";
import City from "../features/city/City";
import Service from "../features/service/Service";
import Specialties from "../features/specialties/Specialties";
import Facility from "../features/facility/Facility";
import Hospital from "../features/hospital/Hospital";
import CreateHospital from "../features/hospital/CreateHospital";
import HospitalType from "../features/hospitaltype/HospitalType";
import ShiftSettings from "../features/shiftsettings/ShiftSettings";
import Branch from "../features/branch/Branch";
import Doctor from "../features/doctor/Doctor";
import CreateDoctor from "../features/doctor/CreateDoctor";
import Appointment from "../features/Appointment/Appointment";

const MainRouter = () => {
  const navigate = useNavigate();
  return (
    <Routes>
      <RouteItem
        path="login"
        element={
          <PrivateLoginRoute>
            <LoginNew />
          </PrivateLoginRoute>
        }
      />
      <RouteItem
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <RouteItem index={true} element={<Dashboard />} />
        <RouteItem path="menu" element={<Menu />} />
        <RouteItem path="rights" element={<Rights />} />
        <RouteItem path="degree" element={<Degree />} />
        <RouteItem path="country" element={<Country />} />
        <RouteItem path="state" element={<State />} />
        <RouteItem path="city" element={<City />} />
        <RouteItem path="service" element={<Service />} />
        <RouteItem path="speciality" element={<Specialties />} />
        <RouteItem path="Facility" element={<Facility />} />
        <RouteItem path="hospitaltype" element={<HospitalType />} />
        <RouteItem path="shiftsetting" element={<ShiftSettings />} />
        <RouteItem path="branch" element={<Branch />} />

        <RouteItem path="testimonial" element={<Testimonial />} />
        <RouteItem path="gallery" element={<Gallery />} />

        <RouteItem path="doctor" element={<Doctor />} />
        <RouteItem path="doctor/create" element={<CreateDoctor />} />
        <RouteItem path="doctor/edit" element={<CreateDoctor />} />

        <RouteItem path="hospital" element={<Hospital />} />
        <RouteItem path="hospital/create" element={<CreateHospital />} />
        <RouteItem path="hospital/edit" element={<CreateHospital />} />

        <RouteItem path="user" element={<User />} />
        <RouteItem path="user/create" element={<CreateUser />} />
        <RouteItem path="user/edit" element={<CreateUser />} />

        <RouteItem path="attractions" element={<Attractions />} />
        <RouteItem path="attractions/create" element={<CreateAttractions />} />
        <RouteItem path="attractions/edit" element={<CreateAttractions />} />

        <RouteItem path="banner" element={<Banner />} />
        <RouteItem path="banner/create" element={<CreateBanner />} />
        <RouteItem path="banner/edit" element={<CreateBanner />} />

        <RouteItem path="seotag" element={<SeoTag />} />
        <RouteItem path="seotag/create" element={<CreateSeoTag />} />
        <RouteItem path="seotag/edit" element={<CreateSeoTag />} />

        <RouteItem path="blog" element={<Blog />} />
        <RouteItem path="blog/create" element={<CreateBlog />} />
        <RouteItem path="blog/edit" element={<CreateBlog />} />

        <RouteItem path="faq" element={<FAQ />} />
        <RouteItem path="faq/create" element={<CreateFAQ />} />
        <RouteItem path="faq/edit" element={<CreateFAQ />} />

        <RouteItem path="cms" element={<CMS />} />
        <RouteItem path="cms/edit" element={<CreateCMS />} />
        <RouteItem path="cms/create" element={<CreateCMS />} />
        <RouteItem path="usertype" element={<UserType />} />
        <RouteItem path="usertype/create" element={<CreateUserType />} />
        <RouteItem path="usertype/edit" element={<CreateUserType />} />
        <RouteItem path="inquiry" element={<Inquiry />} />
        <RouteItem path="appointment" element={<Appointment />} />
        <RouteItem path="setting" element={<Setting />} />
        {/* <RouteItem path="inquiry/create" element={<CreateInquiry />} />
        <RouteItem path="inquiry/edit" element={<CreateInquiry />} /> */}
      </RouteItem>
      <RouteItem
        path="*"
        element={
          <RippleButton
            onClick={() => navigate("/")}
            style={{ margin: "20px" }}
          >
            Back to Home
          </RippleButton>
        }
      />
    </Routes>
  );
};

export default MainRouter;
